import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
/* Layout */
import Layout from '@/views/layout/adminLayout'
const _import = require('./_import_' + process.env.NODE_ENV)
Vue.use(Router)

export const constantRouterMap = [{
  path: '/login',
  // component: _import('login/index')
  component: _import('login/loginThree')
},
{
    path: '/moodle',
    // component: _import('login/index')
    component: _import('login/moodle')
},
{
  path: '/redirect',
  component: _import('login/loginThree')
},
{
  path: '/loginAuto',
  component: _import('login/loginAuto')
},
{
  path: '/clientAutoLogin',
  component: _import('login/clientAutoLogin')
},
{
  path: '/oidc-callback',
  component: _import('login/oidc-callback')
},
{
  path: '/404',
  component: _import('errorPages/404')
},
{
  path: '/500',
  component: _import('errorPages/500')
},
{
  path: '/welcome',
  component: _import('login/welcome')
},
{
  path:'/forgetPassword',
  component:_import('login/forgetPassword')
},
{
  path:'/retrieveEmail',
  component:_import('login/retrieveEmail')
},
{
  path:'/tutorClient',
  component:_import('login/tutorClient')
},
{
  path: '/test',
  component: _import('test/index'),
  name: 'agora-test'
},
{
  path: '/speed',
  component: _import('speed/index'),
  name: 'speed'
}
]

export default new Router({
  // scrollBehavior: () => ({ y: 0 }),
  mode: 'history',
  routes: constantRouterMap
})
export const asyncRouterMap = [{
  path: '',
  redirect: 'home',
  component: Layout,
  children: [{
    path: 'home',
    component: _import('dashboard/index'),
    name: 'home'
  },
  {
    // SOP路由
    path: '/SOP',
    redirect: '/SOP/scoreClass',
    component: _import('SOP/index'),
    name: 'SOP',
    children: [
      {
        path: '/SOP/scoreClass',
        component: _import('SOP/scoreClass'),
        name: 'scoreClass'
      },
      {
        path: '/SOP/assessmentSummary',
        component: _import('SOP/assessmentSummary'),
        name: 'assessmentSummary'
      },
    ]
  },
  {
    // 课表页路由
    path: '/classTab',
    component: _import('classTab/index'),
    name: 'classTab'
  },
  {
    // 薪资页面路由
    path: '/serviceFee',
    redirect: '/serviceFee/accounting',
    component: _import('salary/index'),
    name: 'serviceFee',
    children: [{
      path: '/serviceFee/accounting',
      component: _import('salary/accounting/index'),
      name: 'accounting'
    },
    {
      path: '/serviceFee/paymentRecord',
      component: _import('salary/paymentRecord/index'),
      name: 'paymentRecord'
    },
    {
      path: '/serviceFee/historyRemarks',
      component: _import('salary/historyRemarks/index'),
      name: 'historyRemarks'
    },
    {
      path: '/serviceFee/completedClasses',
      component: _import('salary/completedClasses/index'),
      name: 'completedClasses'
    }
    ]
  },
  {
    // 抱怨列表页路由
    path: '/complaintList',
    redirect: '/complaintList/recitationClassesReport',
    component: _import('complaintList/complaintList'),
    name: 'complaintList',
    children: [
    {
      path: '/complaintList/recitationClassesReport',
      component: _import('complaintList/recitationClassesReport'),
      name: 'recitationClassesReport'
    },
    {
      path: '/complaintList/receivedComplaint',
      component: _import('complaintList/receivedComplaint'),
      name: 'receivedComplaint'
    },
    {
      path: '/complaintList/lateAttendanceEarlyLeave',
      component: _import('complaintList/lateAttendanceEarlyLeave'),
      name: 'lateAttendanceEarlyLeave'
    }
    ]
  },
  {
    // trainingCenter页面
    path: '/trainingCenter',
    redirect: '/trainingCenter/trainingOverview',
    component: _import('trainingCenter/trainingCenter'),
    name: 'trainingCenter',
    children: [{
      path:'/trainingCenter/trainingOverview',
      component: _import('trainingCenter/trainingOverview'),
      name: 'trainingOverview'
    },
    {
      path:'/trainingCenter/mySubscription',
      component: _import('trainingCenter/mySubscription'),
      name: 'mySubscription'
    },
    {
      path: '/trainingCenter/selfstudyCourses',
      component: _import('trainingCenter/selfstudyCourses'),
      name: 'selfstudyCourses'
    },
    {
      path: '/trainingCenter/onlineTraining',
      component: _import('training/training'),
      name: 'onlineTraining'
    },
    {
      path:'/trainingCenter/moodleMessage',
      component:_import('trainingCenter/moodleMessage'),
      name:'moodleMessage'
    }
    ]
  },
  {
    path:'/trainingCenter/courseDetail/:id',
    component:_import('trainingCenter/courseDetail'),
    name:'courseDetail'
  },

  // trainingKit页面
  {
    path: '/trainingKit',
    component: _import('trainingKit/trainingKit'),
    name: 'trainingKit'
  },
  // training页面
  // {
  //   path: '/training',
  //   component: _import('training/training'),
  //   name: 'training'
  // },
  // myReferrals页面
  // {
  //   path: '/myReferrals',
  //   component: _import('myReferrals/myReferrals'),
  //   name: 'myReferrals'
  // },
  {
    path: '/myReferrals',
    component: _import('myReferrals/referralsList/myReferrals'),
    name: 'myReferrals'
  },
  // {
  //   path: '/myReferrals',
  //   redirect: '/myReferrals/referrals/index',
  //   component: _import('myReferrals/referrals/index'),
  //   name: 'myReferrals',
  //   children:[
  //     {
  //       path: '/myReferrals/referrals/index',
  //       component: _import('myReferrals/referrals/index'),
  //       name: 'index'
  //     },
  //     {
  //       path: '/myReferrals/referrals/referralsList',
  //       component: _import('myReferrals/referrals/referralsList'),
  //       name: 'referralsList'
  //     },
  //   ]
  // },
  // myReferrals页面(新)
  {
    path: '/referrals',
    component: _import('myReferrals/referrals/referrals'),
    name: 'referrals'
  },
  // myReferrals列表页面(新)
  {
    path: '/referralsList',
    component: _import('myReferrals/referrals/referralsList'),
    name: 'referralsList'
  },
  // myReferrals规则页面(新)
  {
    path: '/referralStatus',
    component: _import('myReferrals/referrals/referralStatus'),
    name: 'referralStatus'
  },
  {
    // message页面
    path: '/message',
    redirect: '/message/notice',
    component: _import('message/message'),
    name: 'message',
    children: [{
      path: '/message/remind',
      component: _import('message/remind'),
      name: 'remind'
    },
    {
      path: '/message/warning',
      component: _import('message/warning'),
      name: 'warning'
    },
    {
      path: '/message/notice',
      component: _import('message/notice'),
      name: 'notice'
    },
    {
      path: '/message/levelUp',
      component: _import('message/levelUp'),
      name: 'levelUp'
    }
    ]
  },
  {
    // View message页面
    path: '/messageView/:id',
    component: _import('message/messageViewIndex'),
    name: 'messageView',
    children: [{
      path: '/remind',
      component: _import('message/messageView'),
      name: 'messageRemindView'
    },
    {
      path: '/other',
      component: _import('message/messageView'),
      name: 'messageOtherView'
    }
    ]
  },
  {
    // flowers页面
    path: '/flowers',
    redirect: '/flowers/usedFlowers',
    component: _import('flowers/flowers'),
    name: 'flowers',
    children: [{
      path: '/flowers/usedFlowers',
      component: _import('flowers/usedFlowers'),
      name: 'usedFlowers'
    },
    {
      path: '/flowers/obtainedFlowers',
      component: _import('flowers/obtainedFlowers'),
      name: 'obtainedFlowers'
    }
    ]
  },
  {
    // personalData页面
    path: '/personalData',
    redirect: '/personalData/profile',
    component: _import('personalData/personalData'),
    name: 'personalData',
    children: [{
      path: '/personalData/profile',
      component: _import('personalData/profile'),
      name: 'profile'
    },
    {
      path: '/personalData/upload',
      component: _import('personalData/upload'),
      name: 'upload'
    },
    {
      path: '/personalData/interests',
      component: _import('personalData/interests'),
      name: 'interests'
    }
    ]
  },
  {
    // 国际老师合同签署页面
    path: '/signContract',
    component: _import('signContract/index'),
    name: 'signContract'
  },
  {
    // 国际老师合同预览
    path: '/signContract/contract',
    component: _import('signContract/contract'),
    name: 'contract'
  },
  {
    // TESOL认证前担保协议
    path: '/signContract/tesolCertification',
    component: _import('signContract/tesolCertification'),
    name: 'tesolCertification'
  },
  {
    // 定制老师合同签署页面
    path: '/signContractCustom',
    component: _import('signContractCustom/index'),
    name: 'signContractCustom'
  },
  {
    // 定制老师合同预览
    path: '/signContractCustom/contractCustom',
    component: _import('signContractCustom/contractCustom'),
    name: 'contractCustom'
  },
  {
    // 改版老师个人信息页面
    path: '/newPersonalData',
    component: _import('personalData/newPersonalData'),
    name: 'newPersonalData'
  },
  {
    // 学生评论页
    path: '/comments',
    redirect: '/comments/commentDetails',
    component: _import('comments/comments'),
    name: 'comments',
    children: [
      {
        path: '/comments/commentDetails',
        component: _import('comments/index'),
        name: 'commentDetails'
      },
      {
        path: '/comments/labelImpression',
        component: _import('comments/labelImpression'),
        name: 'labelImpression'
      }
    ]
  },
  {
    // Top Tutor排名页面
    path: '/conversionRanking',
    // redirect:'/rankData/conversionRanking',
    component: _import('rankData/conversionRanking'),
    name: 'conversionRanking',
    // children:[
    //   {
    //     path:'/rankData/conversionRanking',
    //     component:_import('rankData/conversionRanking'),
    //     name:'conversionRanking'
    //   },
    //   {
    //     path:'/rankData/progressRanking',
    //     component:_import('rankData/progressRanking'),
    //     name:'progressRanking'
    //   }
    // ]
  },

  { //didi 成功接单排行榜
    path: '/receivedOrdersRanking',
    component: _import('rankData/receivedOrdersRanking'),
    name: 'receivedOrdersRanking',
  },

  { //didi 接单响应率排行榜
    path: '/10sResponseRateRanking',
    component: _import('rankData/10sResponseRateRanking'),
    name: '10sResponseRateRanking',
  },

  { //老师情绪分排行榜
    path: '/emotionalMotivationRanking',
    component: _import('rankData/emotionalMotivationRanking'),
    name: 'emotionalMotivationRanking',
  },

  {
    // classDetail页面,id课程id,state课程状态
    path: '/classDetail/:id/',
    component: _import('classDetail/index'),
    name: 'classDetail'
  },
  {
    // classDetail页面,id课程id,state课程状态
    path: '/classDetailtest',
    component: _import('classDetail/teachingMaterialListRemarkModal'),
    name: 'classDetailTest'
  },
  {
    // trainingkitDetails页面
    path: '/trainingkitDetails/:id',
    component: _import('trainingkitDetails/trainingkitDetails'),
    name: 'trainingkitDetails'
  },
  {
    // 培训资源页面
    path: '/trainingResources/:id',
    component: _import('trainingkitDetails/trainingResources'),
    name: 'trainingResources'
  },
  {
    // 培训资源页面--文件夹里的资源
    path: '/resourcesFolder',
    component: _import('trainingkitDetails/resourcesFolder'),
    name: 'resourcesFolder'
  },
  {
    // releaseTime放课页面
    // 通过TL 3天内：开放3天放课时间 single
    // 通过TL ≥4&&<7天：开放7天放课时间 double
    // 通过TL >=7天：开放21天放课时间 more
    path: '/releaseTime/submit',
    component: _import('classTab/releaseTime'),
    name: 'releaseTime'
  },
  {
    path: '/releaseTime/cancle',
    component: _import('classTab/autonomousCancellation'),
    name: 'autonomousCancellation'
  },
  {
    // trainingTestDetails 教材测评考试页面
    path: '/trainingTestDetails',
    component: _import('trainingkitDetails/trainingTestDetails'),
    name: 'trainingTestDetails'
  },
  {
    // 教材测评查看答案页面
    path:'/trainingTestAnswer',
    component: _import('trainingkitDetails/trainingTestAnswer'),
    name: 'trainingTestAnswer'
  },
  // {
  //   // 语音评测
  //   path: '/accentTest',
  //   component: _import('accentTest/index'),
  //   name: 'accentTest'
  // },
  {
    // 反馈系统
    path: '/myFeedback',
    component: _import('myFeedback/index'),
    name: 'myFeedback'
  },
  {
    // 自主请假
    path: '/leaveRequest',
    redirect: '/leave/leaveRequest',
    component: _import('leave/index'),
    name: 'leaveRequest',
    children: [{
      path:'/leave/leaveRequest',
      component: _import('leave/leaveRequest'),
      name: 'leaveRequest'
    },
    {
      path: '/leave/leaveRecord',
      component: _import('leave/leaveRecord'),
      name: 'leaveRecord'
    }
    ]
  },
  {
    path:'/publicClass',
    component: _import('publicClass/index'),
    name: 'publicClass'
  },
  {
    // 成长中心
    path: '/growthCenter',
    redirect: '/growthCenter',
    component: _import('growthCenter/index'),
    name: 'growthCenterIndex',
    children: [{
      path:'/growthCenter',
      component: _import('growthCenter/growthCenter'),
      name: 'growthCenter'
    },
    {
      path: '/growthCenter/achievementRewards',
      component: _import('growthCenter/achievementRewards'),
      name: 'achievementRewards'
    },
    {
      path: '/growthCenter/strengthAssessment',
      component: _import('growthCenter/strengthAssessment'),
      name: 'strengthAssessment'
    },
    {
      path: '/growthCenter/myGoal',
      component: _import('growthCenter/myGoal'),
      name: 'myGoal'
    }
    ]
  },
  {
    // 可申请teacherTask页面
    path: '/teacherTask',
    component: _import('teacherTask/index'),
    name: 'teacherTask'
  },
  {
    // 我的teacherTask页面
    path: '/teacherTask/myTaskPage',
    component: _import('teacherTask/myTaskPage'),
    name: 'teacherTask'
  },
  ]
},

{
    path: '/js/*',
    name: 'js'
  },
  {
    path: '/css/*',
    name: 'css',
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

